import { Content } from './_card-content';
import { Count } from './_card-count';
import { Title } from './_card-title';

export const ProjectOverviewOverdueTasksCard: {
  Title: typeof Title;
  Content: typeof Content;
  Count: typeof Count;
} = {
  Title,
  Content,
  Count,
};
